function NoDataText() {
  return (
    <>
      <div className="d-flex mt-1 text-opacity-50 small">
        <div className="flex-1 ps-2">
          <div className="text-danger">No Data</div>
        </div>
      </div>
    </>
  );
}

export default NoDataText;
